import { apiClient } from './api';
import { VirtualDrone, VirtualDroneListResponse } from '../types/virtualDrone';

const BASE = '/api/v1/drones/virtual';

/**
 * Operator-owned virtual (simulated) drones (issue #322). All routes are scoped
 * to the authenticated operator server-side; the id_token is attached by the
 * ApiClient request interceptor.
 */
export const virtualDroneService = {
  /** List the operator's virtual drones. */
  async list(): Promise<VirtualDroneListResponse> {
    return apiClient.get<VirtualDroneListResponse>(BASE);
  },

  /** Create a virtual drone. Name is optional. */
  async create(name?: string): Promise<VirtualDrone> {
    const body = name && name.trim() ? { name: name.trim() } : {};
    return apiClient.post<VirtualDrone>(BASE, body);
  },

  /** Delete one of the operator's virtual drones. */
  async remove(id: string): Promise<void> {
    await apiClient.delete<null>(`${BASE}/${id}`);
  },
};
